module.exports = __webpack_public_path__ + "static/media/forward.a9bc2d0d.svg";